import img from '../assets/images/of-the-year.png'

export const subBanner = {
    image: img,
    name: "Product of the year",
    descirption: "Lorem Ipsum is simply dummy text of the printing and typesetting industry orem Ipsum..",
    button: "show Now"
}